// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconButton-module__icon-button--NuL5B{display:flex;align-items:center;justify-content:center;border:none;background:none;padding:0}.IconButton-module__icon-button--NuL5B svg{height:16px;width:16px}.IconButton-module__icon-button--NuL5B:hover svg path{fill:rgba(7,7,7,.55)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-button": `IconButton-module__icon-button--NuL5B`,
	"iconButton": `IconButton-module__icon-button--NuL5B`
};
export default ___CSS_LOADER_EXPORT___;
